import { gettext } from '@eventbrite/i18n';
import React, { useRef } from 'react';
import { useScrollOnCommand } from '../../../contexts/ScrollContext';
import { EventMapScopedProps } from '../../../types';
import {
    Detail,
    DetailContent,
    DetailInner,
} from '../../_shared/Detail/Detail';
import { EventDetailsSectionTitle } from '../EventDetails';
import { Location, LocationProps } from './Location';

type WhenAndWhereProps = {
    location: LocationProps;
    map: Omit<EventMapScopedProps, 'venueName' | 'venueAddress'>;
};

const LABEL_ID = 'location-heading';

export const WhenAndWhere = ({ location, map }: WhenAndWhereProps) => {
    const ref = useRef<HTMLDivElement>(null);
    useScrollOnCommand(ref, 'whenAndWhere');

    return (
        <>
            <span ref={ref} />
            <section aria-labelledby={LABEL_ID}>
                <Detail>
                    <DetailInner>
                        <DetailContent>
                            <EventDetailsSectionTitle>
                                <h2 id={LABEL_ID}>{gettext('Location')}</h2>
                            </EventDetailsSectionTitle>
                            <Location location={location} map={map} />
                        </DetailContent>
                    </DetailInner>
                </Detail>
            </section>
        </>
    );
};
